import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject, of, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { ClearanceItem, CIDocument, CIImage, CIRestriction, CITag, CISignedUrl, ListSearchData, MassUpdateData } from './index';
import { AuthService, IUserInfo } from '../shared/core/index';
// import 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';

import { HttpService } from '../shared/core/http.service';
import { AppService } from '../app.service';
import { tap } from 'rxjs/operators';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ClearanceItemImageService {   
    private userInfo: IUserInfo; 

    private ciImageServiceAPIUrl = new URL('ciimage', environment.apiUrl).toString();
    
    private _currentClearanceItem = new BehaviorSubject<ClearanceItem>(new ClearanceItem());
    CurrrentClearanceItem = this._currentClearanceItem.asObservable();

    constructor(private _httpService: HttpService, private _authService: AuthService, private sanitizer: DomSanitizer, private _appService: AppService) {
        this._authService.subscribeToLoginService().subscribe(r => { this.userInfo = r });
    }

    patchImageNotes(ciimage: CIImage): Observable<boolean> {
        var body = JSON.stringify(ciimage);
        return this._httpService.httpPatch(this.ciImageServiceAPIUrl+'/patchCIImageNotes', body).pipe(
        map(() => true),
        catchError(e => {
            console.error('updateCICimage:' + e._body);
            return of(false);
        })
);
    }
    
    patchImageMarkAsDeleted(ciimage: CIImage): Observable<boolean> {
        var body = JSON.stringify(ciimage);
        return this._httpService.httpPatch(this.ciImageServiceAPIUrl+'/patchCIImageMarkAsDeleted', body).pipe(
            map(() => true),
            catchError(e => {
                console.error('updateCICimage:' + e._body);
                return of<any>(false);
            }
        ));
    }

    private handleError(error: any) {
        return throwError(() => error || 'Server error');
    }

    public getOriginalImagesFullUrls(CI: ClearanceItem): Observable<CISignedUrl>[]{
        return CI.images.map(image => {
            return this._appService.getSignedUrlInline(image.url, CI.projectId,'GET','image','ci',image.urlName);        
        });
    }
}
